import Vue               from 'vue'
import VueRouter         from 'vue-router'
import StringTranslation from './string-translation.vue'
import TranslationTab    from './components/string-translation/translation-tab.vue'

Vue.use( VueRouter )

var etm_paths = []
for ( var etm_path_index in etm_string_translation_data.string_types_config ) {
    if ( etm_string_translation_data.string_types_config[ etm_path_index ][ 'category_based' ] ){
        etm_paths.push( {
                            path      : '/' + etm_path_index + '/',
                            component : TranslationTab,
                            props     : {
                                translationTab        : true,
                                translationType       : Object.keys( etm_string_translation_data.string_types_config[ etm_path_index ].categories )[ 0 ],
                                currentTab            : etm_string_translation_data.string_types_config[ etm_path_index ].categories[ Object.keys( etm_string_translation_data.string_types_config[ etm_path_index ].categories )[ 0 ] ],
                                parentTab             : etm_string_translation_data.string_types_config[ etm_path_index ],
                                parentTranslationType : etm_path_index
                            }
                        } )
        for ( var etm_path_category_index in etm_string_translation_data.string_types_config[ etm_path_index ].categories ) {
            etm_paths.push( {
                                path      : '/' + etm_path_index + '/' + etm_path_category_index + '/',
                                component : TranslationTab,
                                props     : {
                                    translationTab        : true,
                                    translationType       : etm_path_category_index,
                                    currentTab            : etm_string_translation_data.string_types_config[ etm_path_index ].categories[ etm_path_category_index ],
                                    parentTab             : etm_string_translation_data.string_types_config[ etm_path_index ],
                                    parentTranslationType : etm_path_index
                                }
                            } )
        }
    } else {
        etm_paths.push( {
                            path      : '/' + etm_path_index + '/',
                            component : TranslationTab,
                            props     : {
                                translationTab        : true,
                                translationType       : etm_path_index,
                                currentTab            : etm_string_translation_data.string_types_config[ etm_path_index ],
                                parentTab             : false,
                                parentTranslationType : false
                            }

                        } )
    }
}

// redirect all unregistered paths to first path
var first_tab = etm_paths[0]
first_tab.path = '*'
etm_paths.push(first_tab)

/** Future use **/
// etm_paths.push(
//     { path : '/import-export/', component : ImportExport, props : {} }
// )

const router = new VueRouter( {
                                  'routes'             : etm_paths,
                                  linkExactActiveClass : 'nav-tab-exact-active',
                                  linkActiveClass      : 'nav-tab-active'
                              } )


if ( document.getElementById( 'etm-editor-container' ) ){

    window.tpStringTranslationApp = new Vue( {
                                                 components : {
                                                     'etm-string-translation' : StringTranslation
                                                 },
                                                 el         : '#etm-editor-container',
                                                 data       : {},
                                                 router
                                             } )

}
